import React, { useContext } from "react";
import Form from "react-bootstrap/Form";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../Landing/Components/Api/Api";
import SweetAlert from "../Landing/Components/SweetAlert/SweetAlert";
import Button from "react-bootstrap/Button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InputFormat } from "../Landing/Components/FormOptions/InputFormat";
import { fetchData } from "../Cpanel/Components/Utilities";
import { ShopContext } from "../StateManagement/Contexts/ShopContext";
import AvatarImage from "../Assets/images/download.png";
import Swal from "sweetalert2";
export const ShopGallery = () => {
  const [showEditComponent, setShowEditComponent] = useState(false);
  const [image, setImage] = useState("");
  const { shopData } = useContext(ShopContext);
  console.log(shopData?.ShopId);
  const toast = useRef(null);
  const [editingImageId, seteditingImageId] = useState("");
  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "لغو شد",
      detail: "درخواست حذف لغو شد",
      life: 3000,
    });
  };
  const [initialValues, setIntialValues] = useState([]);

  const [Logo, setLogo] = useState({});

  useEffect(() => {
    fetchData("shoppanelgallery", {}, handleApiResponse);
  }, []);

  const handleApiResponse = (data) => {
    // Your response handling logic here
    const initData = data?.dt?.filter((img) => img.Position === 0);
    setIntialValues(initData);
    reset({ ...initData });
  };

  const defaultValues = {
    title: "",
    pic: "",
    status: "",
    sort: "",
    idofshop: "",
  };

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({ defaultValues });
  const onSubmit = async (data) => {
    let status;
    if (data?.status) {
      status = 1;
    } else {
      status = 0;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("idofshop", shopData?.ShopId);
    bodyFormData.append("title", data?.title);
    bodyFormData.append("sort", data?.sort ? data?.sort : "9");
    bodyFormData.append("pic", typeof image === "string" ? "" : image);
    bodyFormData.append("status", status);
    let cmd = "insertgalleryshop";
    if (editingImageId) {
      cmd = "updategalleryshop";
      bodyFormData.append("id", editingImageId);
    }
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: cmd,
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        const data = responseGlobal?.data;
        if (responseGlobal?.data?.UserId === "0") {
        }
        if (data?.code === 1) {
          SweetAlert({
            title: "",
            text: "اطلاعات اولیه با موفقیت ذخیره شد.",
            type: "success",
          });
        }
      } else {
        SweetAlert({
          title: "",
          text: `${data?.msg}`,
          type: "error",
        });
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  const handleUpload = async (w, h, sednFile) => {
    if (!sednFile) {
      return;
    }
    const image = new Image();
    image.src = sednFile;
    const cWith = w;
    const cHeight = h;
    let percentWidth = 0;
    let percentHeight = 0;
    image.onload = async () => {
      const canvas = document.createElement("canvas");
      const orginalWidht = image.naturalWidth;
      const orginalHeight = image.naturalHeight;
      if (cWith === 0 || cHeight === 0) {
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
      } else {
        percentWidth = cWith / orginalWidht;
        percentHeight = cHeight / orginalHeight;
        const percent =
          percentHeight < percentWidth ? percentHeight : percentWidth;
        canvas.width = image.naturalWidth * percent;
        canvas.height = image.naturalHeight * percent;
      }

      canvas
        .getContext("2d")
        .drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(async (blob) => {
        const myImage = new File([blob], "my-new-name.webp", {
          type: blob.type,
        });

        setImage(myImage);
      }, "image/webp");
    };
  };
  const handleSendImage = (slide) => {
    const width = 800;
    const height = 800;
    handleUpload(width, height, Logo);
  };

  const handleDeleteImage = async (id) => {
    const bodyFormData = new FormData();
    bodyFormData.append("id", id);
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "deletegalleryshop",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
        }
        toast.current.show({
          severity: "info",
          summary: "تایید شد",
          detail: "درخواست شما انجام شد",
          life: 3000,
        });
        fetchData("shopgallery", {}, handleApiResponse);
        setImage(null);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  const handleDelete = (id) => {
    // confirmDialog({
    //   message: "آیا می خواهید بنر را حذف کنید؟",
    //   header: "حذف بنر",
    //   icon: "pi pi-info-circle",
    //   defaultFocus: "reject",
    //   acceptClassName: "p-button-danger",
    //   accept: () => handleDeleteImage(id),
    //   reject: () => reject(),
    // });
    Swal.fire({
      show: true,
      title: "حذف بنر",
      text: "آیا می خواهید بنر را حذف کنید؟",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      cancelButtonColor: "#d33",
      icon: "success",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleDeleteImage(id);
      }
    });
  };

  const submitEdit = (slide) => {
    setShowEditComponent(true);
    seteditingImageId(slide?.id);
    if (slide) {
      reset({ ...slide });
      setImage(slide?.img ?? null);
    } else {
      reset(defaultValues);
      setImage(null);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
        <div className="panel panel-primary">
          <div className="panel-heading text-info prime-bg text-white text-center py-2 my-0">
            گالری تصاویر
          </div>
          <div className="panel-body ">
            <div className="row hidden-xs">
              <div className="col-md-2 nopaddingmob col-xs-4">اولویت</div>
              <div className="col-md-2 nopaddingmob col-xs-4">عنوان</div>
              <div className="col-md-3 nopaddingmob col-xs-4">لینک</div>
              <div className="col-md-2 nopaddingmob col-xs-4">عکس</div>
              <hr className="hidden-xs" />
            </div>
            {initialValues?.map((slide) => {
              return (
                <div
                  key={slide?.BannerId}
                  className="row d-flex justify-content-between align-items-center  multi-slide-box"
                >
                  <div className=" col-md-6 mauto nopaddingmob col-xs-9 ">
                    <div className="d-flex flex-row align-items-center justify-content-between gap-1">
                      <p>{slide?.sort}</p>
                      <p>{slide?.title}</p>
                      <p>{slide?.link}</p>
                    </div>
                  </div>

                  <div className="col-md-4 mauto nopaddingmob col-xs-12 pb-2">
                    <br className="hidden-md" />
                    <span className="hidden-md">جهت تغییر عکس را لمس کنید</span>
                    <img
                      className="banner-set-image rounded"
                      alt="عکس بنر را انتخاب کنید.."
                      src={`https://api.taab30.com${slide?.img}`}
                    />
                  </div>
                  <div className="col-md-1 mauto nopaddingmob col-xs-12 ">
                    <div className="d-flex flex-column justify-content-between align-items-center gap-1">
                      <Button
                        onClick={() => handleDelete(slide?.BannerId)}
                        type="button"
                        className="btn btn-danger"
                      >
                        <FontAwesomeIcon icon={"remove"} className="fs-6 " />
                      </Button>
                      <Button type="button" onClick={() => submitEdit(slide)}>
                        <FontAwesomeIcon icon={"edit"} className="fs-6" />
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="row">
              <div className="col-12 m-2">
                <Button className="" onClick={() => submitEdit()}>
                  {" "}
                  افزودن عکس جدید
                </Button>
              </div>
            </div>

            {showEditComponent && (
              <>
                <div className="panel-heading text-info prime-bg text-white text-center py-2 my-0 ">
                  افزودن عکس
                  <span id="ContentPlaceHolder1_lblsizemainbanner">
                    {/* 1780x890px */}
                  </span>
                </div>
                <Row>
                  <Col className="col-12 col-lg-6">
                    <InputFormat
                      control={control}
                      name="sort"
                      type={"tel"}
                      defaultValue={""}
                      label="اولویت"
                      errors={errors}
                    />
                  </Col>
                  <Col className="col-12 col-lg-6">
                    <InputFormat
                      control={control}
                      name="title"
                      type={"text"}
                      label="عنوان "
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row>
                  {/* <Col className="col-12 col-lg-6">
                    <InputFormat
                      control={control}
                      name="link"
                      type={"text"}
                      label="لینک"
                      errors={errors}
                    />
                  </Col> */}
                  <Col className="col-12 col-lg-6">
                    <br className="hidden-md" />
                    <span className="hidden-md">جهت تغییر عکس را لمس کنید</span>
                    <img
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                      className="banner-set-image rounded border p-2 w-75"
                      alt="عکس را انتخاب کنید"
                      src={
                        typeof image === "string"
                          ? `https://api.taab30.com${image}`
                          : `${Logo}`
                      }
                    />
                    <input
                      type="file"
                      id="fileInput"
                      className="d-none"
                      onChange={(e) => {
                        if (e.target.files.length > 0) {
                          setLogo(URL.createObjectURL(e.target.files[0]));
                        }
                        setTimeout(() => {
                          document.getElementById("btn-upload").click();
                        }, 1);
                      }}
                    />
                    <button
                      id="btn-upload"
                      className="d-none"
                      type="button"
                      onClick={() => handleSendImage()}
                    >
                      click
                    </button>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-12 col-lg-6"></Col>
                  <Col className="col-12 col-lg-6">
                    <div className="d-flex flex-row justify-content-center mt-5 align-items-between gap-2">
                      <Button
                        className="bg-info btn"
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        }
                        type="button"
                      >
                        انتخاب عکس
                      </Button>

                      <Button type="submit" className="bg-success">
                        ذخیره
                      </Button>
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </div>
        </div>
      </Form>
    </>
  );
};
